export default {"src":"/_next/static/media/tc.15bdf019.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};